import { clearPersistStore } from 'modules/store';
import { storageService } from 'services/storage';
import { useLogout as useLogoutQuery } from 'shared/data/webApp/v1';

import { activeCompanyIdState } from '../states';
import { jotaiStore } from '../store';

export const useLogout = () => {
    const { mutate: logout, ...rest } = useLogoutQuery({
        onSettled: async () => {
            await clearPersistStore();
            jotaiStore.set(activeCompanyIdState, '');
            storageService.setAuthenticated(false);
        },
    });

    return {
        ...rest,
        logout: () => logout({}),
    };
};
